import { PERMISSIONS, userHasPermission } from 'constants/permissions';

function canSeeInpatientSection(user) {
  return (
    userHasPermission(user, PERMISSIONS.SCHEDULE) ||
    userHasPermission(user, PERMISSIONS.MEDICAL_RECORDS) ||
    userHasPermission(user, PERMISSIONS.CLIENTS)
  );
}

function isAnesthesiologistUser(user) {
  return Boolean(user?.isAnesthesiologist || user?.role === 'anesthesiologist');
}

function isDoctorUser(user) {
  return Boolean(
    user?.role === 'doctor' ||
      user?.role === 'surgeon' ||
      user?.role === 'anesthesiologist' ||
      user?.role === 'imaging' ||
      user?.isDoctor
  );
}

/** Для врача: «Приём» — Амбулаторные / Исследования / Стационар. Хирургия — отдельный раздел меню. */
export function transformDoctorSidebarRoutes(routes, user) {
  if (!isDoctorUser(user)) return routes;

  const isAnesthesiologist = isAnesthesiologistUser(user);

  return routes.flatMap((route) => {
    if (route.path !== '/reception' || !route.component) return [route];

    const items = [];

    if (userHasPermission(user, PERMISSIONS.UPCOMING_APPOINTMENTS) && !isAnesthesiologist) {
      items.push({
        name: 'Амбулаторные',
        layout: '/admin',
        path: '/reception',
        sidebarSection: 'ambulatory',
        permissions: [PERMISSIONS.UPCOMING_APPOINTMENTS],
        component: route.component,
      });
      items.push({
        name: 'Исследования',
        layout: '/admin',
        path: '/reception',
        sidebarSection: 'investigations',
        permissions: [PERMISSIONS.UPCOMING_APPOINTMENTS],
        component: route.component,
      });
    }

    if (canSeeInpatientSection(user) && !isAnesthesiologist) {
      items.push({
        name: 'Стационар',
        layout: '/admin',
        path: '/reception',
        sidebarSection: 'inpatient',
        permissions: [
          PERMISSIONS.SCHEDULE,
          PERMISSIONS.MEDICAL_RECORDS,
          PERMISSIONS.CLIENTS,
        ],
        component: route.component,
      });
    }

    if (items.length === 0) {
      return [];
    }

    return [
      {
        ...route,
        collapse: true,
        items,
      },
    ];
  });
}
